import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// material
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import { ResearcherCardAdminTable } from "../components/_dashboard/app";
import { getResearchCardPostdocAdmin } from "../core/service/researchCardPostdoc.service";
// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function ResearcherCard() {
  const navigate = useNavigate();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [listResearchCardPostdoc, setListResearchCardPostdoc] = useState([{}]);
  const { entities } = listResearchCardPostdoc;

  const researchCardPostdocAdmin = async () => {
    const data = await getResearchCardPostdocAdmin();
    setListResearchCardPostdoc(data);
  };

  useEffect(() => {
    if (currentUser.role != ROLE_ADMIN) {
      navigate("/404", { replace: true });
    }
    researchCardPostdocAdmin();
  }, []);

  return (
    <Page title="Researcher Card">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={12}>
            <ResearcherCardAdminTable listResearchCard={entities || []} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
